<template>
  <div class="main">
    <div class="logo"  data-aos="fade-up">
      <a href="javascript:void(0)"></a>
    </div>
    <div class="main__content">
      <div class="main__label"  data-aos="fade-up" data-aos-delay="400">АЛФАВИТ ЖИЗНИ</div>
      <div class="main__title"  data-aos="fade-up" data-aos-delay="800">«КРАСИВЫХ РУССКИХ»</div>
      <div class="main__text"  data-aos="fade-up" data-aos-delay="1200">Красота и роскошь, легкомыслие <span></span>и вседозволенность — вот слова, которые доносят до нас отголоски былого противостояния богемы и буржуазии тех самых «ревущих двадцатых», беспрецедентно наглой эпохи, когда, казалось, возможно всё! Что это за время — время тяжелейшей лёгкости, так заманчиво увлекающей за собой на самое дно? К премьере сериала «Вертинский», о великом шансонье <span></span>и одном из главных лиц той эпохи, мы составили для вас гид о «ревущих двадцатых» — алфавит жизни <span></span>«красивых русских»! </div>
      <div class="main__button"  data-aos="fade-up" data-aos-delay="1400">
        <a href="https://kion.onelink.me/aJR1?pid=dcm_media&is_retargeting=true&af_click_lookback=30d&af_dp=https%3A%2F%2Fkion.ru%2Fvideo%2Fserial%2F414221777%2Fseason%2F414220180%2Fepisode%2F414224945&af_web_dp=https%3A%2F%2Fkion.ru%2Fvideo%2Fserial%2F414221777%2Fseason%2F414220180%2Fepisode%2F414224945%3Futm_source%3D7days%26utm_medium%3Darticle%26utm_campaign%3Dvertinskij_414221777_q3_2021_abc%26utm_term%3Darticle_c_web_mob_int_article_rf_%26utm_content%3Dspecial&c=vertinskij_414221777_q3_2021_abc&af_adset=7days_article_article_c_web_mob_int_article_rf_special&af_sub1=https%253A%252F%252Fkion.ru%252Fvideo%252Fserial%252F414221777%252Fseason%252F414220180%252Fepisode%252F414224945" target="_blank">Смотреть сериал</a>
      </div>
    <div id="letters"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Main'
}
</script>

<style lang="sass">
  .main
    height: vw(797px)
    width: 100%
    background-image: url(../assets/img/main-bg.png)
    background-repeat: no-repeat
    background-position: 50% 0
    background-size: 100%
    display: flex
    flex-direction: column
    @media screen and (max-width: 999px)
      background-image: url(../assets/img/main-mob.png)
      height: vwm(887px)
    &__label
      font-size: vw(38px)
      font-family: 'ZnikomitNo25'
      text-align: center
      text-transform: uppercase
      margin-top: vw(72px)
      @media screen and (max-width: 999px)
        margin-top: vwm(55px)
        font-size: vwm(27px)
    &__title
      font-size: vw(82px)
      font-family: 'ZnikomitNo25'
      text-align: center
      text-transform: uppercase
      margin-top: vw(11px)
      @media screen and (max-width: 999px)
        margin-top: vwm(7px)
        font-size: vwm(57.4px)
        line-height: vwm(61px)
    &__text
      width: vw(670px)
      margin: auto
      margin-top: vw(23px)
      font-size: vw(16px)
      line-height: vw(20.19px)
      text-align: center
      @media screen and (max-width: 999px)
        color: #000
        font-size: vwm(16.7px)
        line-height: vwm(21.5px)
        width: 89%
        margin: auto
        margin-top: vwm(101px)
        span
          display: block
    &__button
      a
        width: vw(242px)
        height: vw(46px)
        line-height: vw(46px)
        border: 1px solid #fff
        text-align: center
        font-size: vw(20px)
        display: block
        margin-left: auto
        margin-right: auto
        margin-top: vw(49px)
        color: #fff
        transition: all 300ms
        position: relative
        text-decoration: none
        @media screen and (max-width: 999px)
          width: vwm(274px)
          height: vwm(52px)
          line-height: vwm(52px)
          font-size: vwm(22.39px)
          margin-top: vwm(41px)
          color: #000
          border-color: #000
        &:hover
          background-color: #740D0C
          color: #fff
          &:before
            width: calc(100% + vw(15px))
            height: vw(58px)
            @media screen and (max-width: 999px)
              width: calc(100% + vwm(16px))
              height: vwm(60px)
          &:after
            width: calc(100% + vw(15px))
            height: vw(58px)
            @media screen and (max-width: 999px)
              width: calc(100% + vwm(16px))
              height: vwm(60px)
        &:before
          content: ''
          display: block
          width: vw(35px)
          height: vw(35px)
          position: absolute
          border: 1px solid #fff
          border-bottom: none
          border-right: none
          top: vw(-8px)
          left: vw(-8px)
          transition: all 300ms
          @media screen and (max-width: 999px)
            border-color: #000
            width: vwm(35px)
            height: vwm(35px)
            top: vwm(-8px)
            left: vwm(-8px)
        &:after
          content: ''
          display: block
          width: vw(35px)
          height: vw(35px)
          position: absolute
          border: 1px solid #fff
          border-top: none
          border-left: none
          bottom: vw(-8px)
          right: vw(-8px)
          transition: all 300ms
          @media screen and (max-width: 999px)
            border-color: #000
            width: vwm(35px)
            height: vwm(35px)
            bottom: vwm(-8px)
            right: vwm(-8px)
  .logo
    width: vw(359px)
    height: vw(98px)
    background-image: url(../assets/img/logo.png)
    background-size: contain
    background-repeat: no-repeat
    background-position: 50% 50%
    margin: auto
    margin-top: vw(35px)
    transition: all 300ms
    margin-bottom: 0
    @media screen and (max-width: 999px)
      width: vwm(222px)
      height: vwm(62px)
      margin-top: vwm(16px)
    a
      display: block
      width: 100%
      height: 100%
      cursor: default
</style>
